import { LoadableAfterPaint } from '@confluence/loadable';

export const RestrictedPage = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictedPage" */ '../src/RestrictedPage'))
			.RestrictedPage,
});
